import styles from '../../assets/scss/components/collections/collection-summary.module.scss'
import { FC, PropsWithChildren, useState } from 'react'
import { useI18n } from '../i18n.client'

export const CollectionSummary: FC<{ description: string; title: string; translate?: boolean }> = ({
  description,
  title,
  translate = false,
}) => {
  const [i18n] = useI18n()

  return (
    <div className={styles.collectionSummary}>
      <h1 className={styles.title}>{translate ? i18n.translate(title) : title}</h1>
      <div className={styles.description}>
        <ReadMoreReadLess>{translate ? i18n.translate(description) : description}</ReadMoreReadLess>
      </div>
    </div>
  )
}

const ReadMoreReadLess: FC<PropsWithChildren> = ({ children }) => {
  const [i18n] = useI18n()
  const [isOpen, setIsOpen] = useState(false)

  if (!children || children.toString().length <= 420) {
    return <div dangerouslySetInnerHTML={{ __html: children as string }}></div>
  }

  if (isOpen) {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: children }}></div>
        <span onClick={() => setIsOpen(false)}>{i18n.translate('read-less')}</span>
      </>
    )
  }

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: children.toString().substring(0, 420) }}></div>&hellip;{' '}
      <span onClick={() => setIsOpen(true)}>{i18n.translate('read-more')}</span>
    </>
  )
}
